import { _TabEnabledMixin } from "../../../moreCore/_loadingHelpers/Tabbing";
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './contactEditor.html?raw';
import Edit from "../../../moreCore/UI/Edit/Edit";
import PhoneInput from '../../../moreCore/UI/PhoneInput/PhoneInput';
import { CountryCodeIti } from "../../../moreCore/UI/MultiLangEdit/TranslationsForm/TranslationsFormTypes";

class contactEditor extends compose(_TabEnabledMixin) {
    templateString: any = template;

    private editMainDivContainer:HTMLDivElement;

    private mainEditWidget:MdsLax<InstanceType<typeof Edit>>|PhoneInput;
    private currentValue:string|number|any;
    private originalValue:string|number;
    private isDirty = false;

    private countryCode: CountryCodeIti = null;

    private entityID:string;
    private classType:string; //wird eigentlich nur uebergeben um evtl in zukunft anhand des classType ein anderes mainEditWidget zu setzen
    private editInputType:string;

    constructor(classType: string, value: string, editInputType: string, ID: string, country: CountryCodeIti) {
        super(...(arguments as unknown as []));
        this.originalValue = value;
        this.currentValue = value;
        this.entityID = ID;
        this.editInputType = editInputType;

        if (country) this.countryCode = country;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        if (this.editInputType == 'tel') {

            this.mainEditWidget = new PhoneInput(this.countryCode);
        }else{
            this.mainEditWidget = new Edit();
            this.mainEditWidget.setInputType(this.editInputType as any);
        }

        this.mainEditWidget.setValue(this.currentValue, true);
        this.mainEditWidget.placeAt(this.editMainDivContainer);

        //setzt events
        this.mainEditWidget.on("change", lang.hitch(this, this._onEdit_Changed));
        this.mainEditWidget.on("countryDropDown", lang.hitch(this, (state:boolean)=>{
            this.emit("countryDropDown", state);//wir emiten wenn im tele input das countr dropdown geoeffnet wurde um evtl. overflow probleme zu handlen
        }));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);


    }

    private _onEdit_Changed(){
        let newVal = this.mainEditWidget.getValue();

        this.currentValue = newVal;
        this.emit("changed", this);

        //check ob dirty
        if (newVal == this.originalValue){
            this.emit("dirty", false);
        }else{
            this.emit("dirty", true);
        }
    }

    public getIsDirty(){
        return this.isDirty;
    }
    public getID(){
        return this.entityID;
    }
    public focus(){
        if (typeof this.mainEditWidget != 'undefined'){
            this.mainEditWidget.focus();
        }
    }
    public setValue(val:string|number, blockUpdateEvent?:boolean){
        this.currentValue = val;
        this.mainEditWidget.setValue(val, blockUpdateEvent);
    }

    public getValue() {
        return this.currentValue;
    }

}

export default mdsWidget(contactEditor);
